import React from "react";
import { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
const Videomodal = ({triggerGrandchildRefresh}) => {
      const default_value = {
          start_time:'10:00 AM',
          end_time:'10:00 AM',
          title:'Hour One',
      };
  
      const default_description = {
          title:null,
          type:'Facilitator',
          timeSlotdetails:null,
          info1:'<div>Facilitator</div>',
          info2:'<div>Facilitator</div>',
          duration:'10 Minutes',
          description:null,
          videoLink:'https://www.youtube-nocookie.com/embed/zTnQLGERcHo?si=rhn1fycNbJfN74L8&amp;controls=0',
      };
      const [item, setItem] = useState(default_value);
      const [detailes, setdetailes] = useState(default_description);
  
        useEffect(() => {
      const storedItem = JSON.parse(sessionStorage.getItem('video_item_data'));
      if (storedItem) setItem(storedItem);
      const storeddetails = JSON.parse(sessionStorage.getItem('video_item_desctiption'));
      console.log(storeddetails);
      if (storeddetails) setdetailes(storeddetails);
    }, [triggerGrandchildRefresh]);
  return (  
    <div className="modal video-show-modal fade" id="videoModal"  aria-labelledby="videoModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        <span>{detailes.type}</span>
                       {detailes.title}
                      </h5>
                      <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    { detailes.video_type == 1? 
                    <div className="modal-body">
                        <iframe title="Video website iframe" width="100%" height="575" src={detailes.videoLink} frameBorder="0" allowFullScreen>
                        </iframe>
                    </div> :    <div className="modal-body">
                                       <video width="100%" height="100%" controls class="myVideo">
                                        <source src={detailes.videoLink} type="video/mp4" />
                                        <source src={detailes.videoLink} type="video/ogg" />
                                        Your browser does not support HTML video.
                                     </video>
                    </div>}
                  </div>
                </div>
              </div>

  );
};

export default Videomodal;